
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product-updates",
      function () {
        return require("private-next-pages/product-updates/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product-updates"])
      });
    }
  